import { getM8Oauth2URL } from 'services/production/utils/getM8URL';

export const authorizeWithFacebook = async () => {
  const url = getM8Oauth2URL('authorize/facebook');

  window.open(url, '_self');
};
